import { Box, Grid, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export interface TeamGridItemProps {
  selected?: boolean;
}

export const OverviewTeamBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '2px',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: '95vh',
  maxWidth: '928px',
  overflowY: 'visible',
  padding: theme.spacing(2),
  boxShadow: theme.shadows[2],
}));

export const TeamGridItem = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<TeamGridItemProps>(({ theme, selected }) => ({
  backgroundColor: selected ? alpha(theme.palette.busmanColors.busmanLight, 0.2) : theme.palette.background.paper,
  alignItems: 'center',
  borderRadius: '2px',
  display: 'flex',
  flexDirection: 'row',
  border: '2px solid',
  borderColor: selected ? theme.palette.busmanColors.busmanLight : theme.palette.background.default,
  cursor: 'pointer',
  width: '100%',
  minHeight: '64px',
  transition: 'border-color 0.2s',
  '&:hover': {
    backgroundColor: theme.palette.background.default,
  },
}));

export const ItemListContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '2px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  flexGrow: 2,
  height: '95vh',
  maxWidth: '960px',
  padding: theme.spacing(2),
  overflow: 'auto',
  scrollbarWidth: 'thin',
  [theme.breakpoints.down('sm')]: {
    // marginTop: theme.spacing(2),
    height: '100%',
  },
}));
